import React from 'react';
import $ from 'jquery';
import { renderWithRoot, unmountRootAtNode } from '../../utilities/reactRoot';

import { EVENTS } from '../../utilities/CONSTANTS';
import CreateOrEditQuestionModal from './CreateOrEditQuestionModal';
import ConvertGeneratedToQuestionModal from '../convert/ConvertGeneratedToQuestionModal';

const closeCreateQuestionModal = () => {
    unmountRootAtNode($('#react-page-modal')[0]);
    $('#react-page-modal').empty();
};

$('body').on('click', '.new-question-link', (e) => {
    e.preventDefault();
    const initialAssignee = e.target.getAttribute('data-assignee');
    renderWithRoot(<CreateOrEditQuestionModal initialAssignee={initialAssignee} closeModal={closeCreateQuestionModal} />, $('#react-page-modal')[0]);
});

$('body').on('click', '.save-answer-button, .ask-your-team-button', (e) => {
    e.preventDefault();
    let hasAnswer = false;

    if (e.target.classList.contains('save-answer-button')) {
        hasAnswer = true;
    }

    let generatedQuestion;
    let kaiDashboard;
    try {
        generatedQuestion = JSON.parse(e.target.getAttribute('data-question'));
        kaiDashboard = JSON.parse(e.target.getAttribute('data-kai-dashboard'));
    } catch (error) {
        console.error('Failed to parse question data:', error);
        return;
    }
    renderWithRoot(<ConvertGeneratedToQuestionModal generatedQuestion={generatedQuestion} hasAnswer={hasAnswer} kaiDashboard={kaiDashboard} closeModal={closeCreateQuestionModal} />, $('#react-page-modal')[0]);
});

$('body').on('click', '.category-new-question-link', (e) => {
    e.preventDefault();
    const initialCategoryId = parseInt(e.target.getAttribute('data-category-id'));
    const initialFolderId = parseInt(e.target.getAttribute('data-folder-id'));
    renderWithRoot(
        <CreateOrEditQuestionModal initialCategoryId={initialCategoryId} initialFolderId={initialFolderId} closeModal={closeCreateQuestionModal} />,
        $('#react-page-modal')[0],
    );
});

$('body').on('click', '.new-typeahead-question-link', (e) => {
    e.preventDefault();
    const initialTitle = e.target.getAttribute('data-question-title');
    $('#search').blur();
    renderWithRoot(
        <CreateOrEditQuestionModal initialTitle={initialTitle} closeModal={closeCreateQuestionModal} />,
        $('#react-page-modal')[0],
    );
});

$(window).on(EVENTS.CREATE_QUESTION_FROM_SEARCH, (e) => {
    const initialTitle = e.title;
    renderWithRoot(
        <CreateOrEditQuestionModal initialTitle={initialTitle} closeModal={closeCreateQuestionModal} />,
        $('#react-page-modal')[0],
    );
});
